<template>
  <CustomPicker
    :isInDialog="isInDialog"
    :isLoading="isLoading"
    :closeOnSelect="true"
    title="name"
    :inputLabel="inputLabel"
    v-model="selectedGroupClass"
    :items="groupClassList"
    @search="handleSearch"
    @open="onOpen"
    @close="onClose"
  >
    <template #list-footer>
      <li v-show="hasNextPage" ref="load" class="loader">در حال لود...</li>
    </template>
  </CustomPicker>
</template>

<script>
export default {
  emits: ["getGroupClass"],
  props: {
    defaultSelectedGroupClass: {
      type: Object,
      required: false,
    },
    isInDialog: {
      type: Boolean,
      default: false,
    },
    inputLabel: {
      type: String,
      default: "تنظیمات مورد نظر را انتخاب کنید",
    },
  },
  watch: {
    defaultSelectedGroupClass: {
      handler(val) {
        if (val) {
          this.selectedGroupClass = val;
        }
      },
      immediate: true,
    },
    selectedGroupClass: {
      handler(val) {
        this.$emit("getGroupClass", val);
      },
    },
  },
  mounted() {
    this.getAllGroupClassRequest();
    this.observer = new IntersectionObserver(this.infiniteScroll);
  },
  data() {
    return {
      isLoading: false,
      groupClassList: null,
      totalCount: null,
      selectedGroupClass: null,
      groupClassFilters: {
        count: 10,
        pageNumber: 1,
        searchCommand: null,
      },
      timeOut: null,
      observer: null,
    };
  },
  methods: {
    async onOpen() {
      if (this.hasNextPage) {
        this.$nextTick(() => {
          this.observer.observe(this.$refs.load);
        });
      }
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        if (this.hasNextPage) {
          this.groupClassFilters.pageNumber++;
        }
      }
    },
    onClose() {
      this.observer.disconnect();
    },
    handleSearch(searchValue, loadingFn) {
      if (this.timeOut) {
        clearTimeout(this.timeOut);
      }
      this.timeOut = setTimeout(async () => {
        this.groupClassFilters.searchCommand = searchValue;
        loadingFn(true);
        await this.getAllGroupClassRequest();
        loadingFn(false);
      }, 300);
    },
    async getAllGroupClassRequest() {
      try {
        this.isLoading = true;
        const _this = this;
        const getAllGroupClass = new GetAllGroupClass(_this);
        getAllGroupClass.setRequestParam(_this.groupClassFilters);
        await getAllGroupClass.fetch((res) => {
          _this.groupClassList = res.data.data;
          _this.totalCount = res.data.total;
        });
      } catch (error) {
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    hasNextPage() {
      if (
        this.totalCount &&
        this.totalCount / this.groupClassFilters.count >
          this.groupClassFilters.pageNumber
      ) {
        return true;
      }
      return false;
    },
  },
  components: {
    CustomPicker,
  },
};
import CustomPicker from "@/views/components/Utils/CustomPicker.vue";
import { GetAllGroupClass } from "@/libs/Api/GroupClass";
</script>
